import React from "react";
import NascarProjections from "./NascarProjections";

export default function TrucksProjections() {
  return <NascarProjections series="trucks" />;
}
